import React from 'react';
import Header from '../../Components/Header';
import Footer from '../../Components/Footer';
import KeywordsManager from '../../Components/KeywordsManager';
import { useAuth } from '../../Contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const AdminKeywordsPage = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  
  const handleLogout = () => {
    logout();
    navigate('/login');
  };
  
  return (
    <div className="min-h-screen flex flex-col">
      <Header isMainPage={false} />
      
      <main className="flex-grow py-8">
        <div className="container mx-auto px-6">
          <div className="flex flex-col sm:flex-row justify-between items-center mb-8">
            <h1 className="text-3xl font-bold mb-4 sm:mb-0">SEO Keywords Management</h1>
            <button
              onClick={handleLogout}
              className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors"
            >
              Logout
            </button>
          </div>
          
          <KeywordsManager />
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default AdminKeywordsPage;